module.exports = __webpack_public_path__ + "static/img/official-seal.29603a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/official-seal.png
// module id = 3MW5
// module chunks = 0